import React from "react";

export interface MessageBubbleConfig {
    // Disables the "thumbs up & down & feedback link" after chatbot messages
    disableReactions?: boolean;

    // Disables the ai-guide visual personalizations (currently, just Hats)
    disablePersonalization?: boolean;
}

export const MessageBubbleConfigContext =
    React.createContext<MessageBubbleConfig>({
        disableReactions: false,
        disablePersonalization: false,
    });
